import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=141d543a&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style1 from "./Register.vue?vue&type=style&index=1&id=141d543a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d543a",
  null
  
)

export default component.exports